import { axiosBasic, axiosBearer } from "../config/axios-common";
import DateToStringWithTime from "../helpers/Strings/DateToStringWithTime";
import RequestModel from "../models/Request";

const postCreateOrUpdateRequest = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/request/insertOrUpdate?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};


const postInterestReasons = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/request/interestreasons?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};


const postSpecialauthorization = async (data: any, professionalId: string) => {

    try {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            }
        }
        const response = await axiosBasic.post(`/sam/v1/request/specialauthorization?professionalId=${encodeURIComponent(professionalId)}`, data, config);

        const responseData = await response.data;

        return responseData;

    } catch (e: any) {
        throw e;
    }
};

const getAllRequests = () => {
    return axiosBasic.get("sam/v1/request/getAllTypes").then(response => {
        let requests = response.data.map((row: any) => {
            return {
                "id": row.id,
                "name": row.name,
                "description": row.description,
                "url": row.url
            }
        });
        return requests
    })
        .catch(e => {
            console.log(e)
        });
};

const postReRegistrationRequestIfNotExists = async () => {

    const response = await axiosBearer.post(`/sam/v1/request/reregistration/createRequestIfNotExists`, {});

    const responseData = await response.data;

    return responseData;
};

const getRequestById = async (idRequest: any) => {

    const response = await axiosBearer.get(`/sam/v1/request/getRequestById?requestId=${idRequest}`);

    const responseData = await response.data;

    return responseData;

};

const getAllRequestReRegistration = async (): Promise<RequestModel[]> => {

    const response = await axiosBearer.get(`/sam/v1/request/getAllRequestByTasyCode`).then(response => {

        var result = new Array<RequestModel>();

        if (response.data !== undefined && response.data.length > 0) {

            result = response.data.map((row: any) => {
                let item = RequestModel.NewInstance();

                item.Id = row.id;
                item.CreatedDate = new Date(row.createdDate);
                item.RequestStateName = row.requestStateName;
                item.RequestStateNameToExibition = row.requestStateNameToExibition;
                item.Protocol = row.protocol;
                item.RequestState = row.requestState;
                item.ColorStatus = row.colorStatus;
                item.ConclusionDate = row.conclusionDate;
                item.CreatedDateToFormatted = DateToStringWithTime(new Date(row.createdDate));

                if (item.ConclusionDate !== null && item.ConclusionDate !== undefined) {
                    item.ConclusionDateToFormatted = DateToStringWithTime(new Date(row.conclusionDate));
                }

                return item;
            });
        }

        return result;
    })

    const responseData = await response;

    return responseData;
};


const exportedObject = {
    postCreateOrUpdateRequest,
    postSpecialauthorization,
    postInterestReasons,
    postReRegistrationRequestIfNotExists,
    getAllRequests,
    getAllRequestReRegistration,
    getRequestById
};


export default exportedObject